import { StrutturaVO } from "@app/shared/vo/strutturaVO";
import { VoceCorrelataClassificaVO } from "@app/shared/vo/voce-correlata-classificaVO";
import { TipologiaFascicoloCorrelataVO } from "./tipologia-fascicolo-correlataVO";
import { VersioneFuturaVO } from "./versione-futuraVO";

export class VoceClassificaVO {
  id: string;
  ente: string;
  codice: string;
  nome: string;
  descrizione: string;
  dataCreazione: string;
  dataModifica: string;
  dataInizioValidita: string;
  dataFineValidita: string;
  riferimentiNormativi: string;
  vociCorrelate: VoceCorrelataClassificaVO[];
  struttureCollegate: StrutturaVO[];
  struttureProprietarie: StrutturaVO[];
  tipologieFascicolo: TipologiaFascicoloCorrelataVO[];
  countChildren: number;
  versioneFutura: VersioneFuturaVO;
  cancellata: boolean;
  abilitaInvioComunicazioniDipendenti: boolean;
  // per la stampa
  output: string;

  public setEmptyVoceClassificaWithCodice(code: string): void {
    this.codice = code;
    this.vociCorrelate = new Array<VoceCorrelataClassificaVO>();
    this.struttureCollegate = new Array<StrutturaVO>();
    this.struttureProprietarie = new Array<StrutturaVO>();
    this.tipologieFascicolo = new Array<TipologiaFascicoloCorrelataVO>();
  }
}
